/* eslint-disable camelcase */
export default class ProductMapUrl {
  constructor ({ url, polling_interval_seconds }) {
    if (!url) throw Error('Url is a required paramater and it can not be empty')
    this.pollingIntervalMiliSeconds = polling_interval_seconds * 1000 || 5000
    this.url = url
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/models/ProductMapUrl.js